import { $generateHtmlFromNodes } from '@lexical/html';
import { html } from 'js-beautify';
import { EditorConfig, createEditor } from 'lexical';
import { lexicalCTAEditorConfig, lexicalTextEditorConfig } from 'modules/Lexical/editors';
import { EXPORT_TRANSLATION_PACKAGE_NODES_TEXT, EXPORT_TRANSLATION_PACKAGE_NODES_CTA } from '../nodes';

const convertLexicalStateToHtml = (serializedState: string | undefined | null, editorConfig: EditorConfig): string => {
  if (serializedState) {
    const editor = createEditor(editorConfig);
    const editorState = editor.parseEditorState(serializedState);
    editor.setEditorState(editorState);

    return editor.read(() => {
      const htmlString = $generateHtmlFromNodes(editor, null);

      return html(htmlString, { indent_size: 2 });
    });
  }

  return '';
};

export const convertLexicalTextEditorStateToHtml = (serializedState: string | undefined): string => {
  const textEditorConfigForExport = {
    ...lexicalTextEditorConfig,
    nodes: [
      ...lexicalTextEditorConfig.nodes,
      ...EXPORT_TRANSLATION_PACKAGE_NODES_TEXT,
    ],
  };

  return convertLexicalStateToHtml(serializedState, textEditorConfigForExport);
};

export const convertLexicalCTAEditorStateToHtml = (serializedState: string | undefined | null): string => {
  const callToActionEditorConfigForExport = {
    ...lexicalCTAEditorConfig,
    nodes: [
      ...lexicalCTAEditorConfig.nodes,
      ...EXPORT_TRANSLATION_PACKAGE_NODES_CTA,
    ],
  };

  return convertLexicalStateToHtml(serializedState, callToActionEditorConfigForExport);
};
